import { createElementBlock as o, openBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), o("svg", r, e[0] || (e[0] = [
    n("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14 3H5.571A2.57 2.57 0 0 0 3 5.571V18.43A2.57 2.57 0 0 0 5.571 21H18.43A2.57 2.57 0 0 0 21 18.429V10m.96-5.35a1.845 1.845 0 0 0-2.61-2.61l-6.644 6.647a1.3 1.3 0 0 0-.328.543l-.864 2.849a.327.327 0 0 0 .408.407l2.849-.864c.205-.062.391-.174.543-.325l6.645-6.647Z"
    }, null, -1)
  ]));
}
const d = { render: l };
export {
  d as default,
  l as render
};
